export { MinifiedTableOfContent } from './MinifiedTableOfContent';
export { DetailedTableOfContent } from './DetailedTableOfContent';